// src/data/editions/index.js
//
// EDITIONS are vertical "skins" of the enterprise console. The components are
// neutral renderers; everything that differs between an insurer (Alberta Blue
// Cross) and an operator (CommuteAir) — taxonomy, copy, the funnel, the ROI
// benchmarks, the brand palette — lives in one of these data modules. Adding a
// vertical (e.g. sport, for Hockey Alberta) is a new module here, not a fork.
//
// Edition shape (see insurance.js / aviation.js for the full populated form):
//   {
//     id, label,
//     palette:   { deep, blue, yellow },              // brand hexes -> CSS vars
//     summary:   { capacityScore, workforce, topPriorityGroup, ... },
//     capacityTrend: [ { date, capacity, signal } ],
//     readiness: { scoreLabel, signalSubtext, groups[], signals[] },
//     feedback:  { scopes[], submissions[], sentiment{} },
//     predictive:{ title, intro, lever, ownLabel, tiers[], cards[], footer{} },
//     roi:       { currency, locale, benchmarks{}, companyDefaults{}, termLabels{} },
//     copilot:   { exampleScope }
//   }

import sport from './sport';
import corporate from './corporate';
import insurance from './insurance';
import aviation from './aviation';
import firstresponder from './firstresponder';
import responsible_gaming from './responsible-gaming';
import schools from './schools';
import compensation from './compensation';

export const EDITIONS = { sport, corporate, insurance, aviation, firstresponder, responsible_gaming, schools, compensation };

// The GENERIC editions (sport / corporate) are the standard skins; the
// specialized verticals (insurance, aviation, firstresponder, the
// responsible_gaming public program, schools for a school division read by
// school) are explicitly selected per org in the super-admin Organization editor.
export const DEFAULT_EDITION = 'corporate';

// Resolve an edition id from an organization document. An explicit valid
// `edition` field wins; otherwise the org's industry picks its generic.
export function resolveEditionId(org) {
    const id = org && org.edition;
    if (EDITIONS[id]) return id;
    return (org && org.industry === 'sport') ? 'sport' : DEFAULT_EDITION;
}

// Get a full edition object by id, always falling back to a valid edition.
export function getEdition(id) {
    return EDITIONS[id] || EDITIONS[DEFAULT_EDITION];
}
